import { Box, Breadcrumbs, Link, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { useSupervisorProjectDetails } from './useSupervisorProjectDetails';
import { getAnnotationToolSupervisorProjectPath } from '../../lib/routePaths';
import { ProjectStats } from '../admin-projects/components/ProjectStats';
import { SupervisorProjectOverview } from './components/SupervisorProjectOverview/SupervisorProjectOverview';

// import { supervisorProjectSlice } from './state/supervisorProjectSlice';

export const SupervisorProjectDetails = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();

  const { projectName, createdOn, startedOn, completedOn, isProjectDetailsLoading } =
    useSupervisorProjectDetails();

  const navigate = useNavigate();
  const handleBackToProjects = () => {
    navigate(getAnnotationToolSupervisorProjectPath());
  };

  return (
    <Box
      sx={{
        px: theme.spacing(6),
        py: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Box>
        <Breadcrumbs sx={{ fontSize: '16px' }} separator="/">
          <Link
            color="inherit"
            underline="hover"
            onClick={handleBackToProjects}
            sx={{ cursor: 'pointer' }}
          >
            {formatMessage({
              id: 'supervisorProjects.projectDetails.breadcrumb.supervisorProjects',
            })}
          </Link>
          <Link color="inherit" underline="none" sx={{ fontWeight: '500' }}>
            {projectName}
          </Link>
        </Breadcrumbs>
      </Box>
      <Box>
        <Typography variant="h4">{projectName}</Typography>
      </Box>
      <Box>
        <ProjectStats
          createdOn={createdOn}
          startedOn={startedOn}
          completedOn={completedOn}
          isLoading={isProjectDetailsLoading}
        />
      </Box>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <SupervisorProjectOverview />
      </Box>
    </Box>
  );
};
